import React from 'react';

const faqs = [
  { q: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?', a: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
  { q: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?', a: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
  { q: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?', a: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
  { q: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?', a: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
  { q: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?', a: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
  { q: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?', a: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
];

export default function FAQSection() {
  return (
    <section id="faqs" className="py-16 px-4 bg-gradient-to-b from-white to-blue-50 text-gray-900">
      <h2 className="text-3xl md:text-4xl font-bold mb-2 text-center">Frequently asked questions</h2>
      <p className="mb-10 text-gray-500 text-center">If you can't find what you're looking for, email our support team and someone will get back to you as soon as possible.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {faqs.map((faq, idx) => (
          <div key={idx} className="bg-white rounded-xl shadow p-6">
            <div className="font-semibold mb-2">{faq.q}</div>
            <div className="text-gray-600 text-sm">{faq.a}</div>
          </div>
        ))}
      </div>
    </section>
  );
} 